import { useEffect, useRef } from "react";

export const usePrevious = (obj) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = obj;
  });
  return ref.current;
};
